import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderStatesCountInput } from './GetOrderStatesCountInput';
import { GetOrderStatesCountOutput } from './GetOrderStatesCountOutput';

export class GetOrderStatesCountService extends HttpServiceBase {

  handle = (input: GetOrderStatesCountInput): Promise<Result<GetOrderStatesCountOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetOrderStatesCountOutput>>(`${this.baseUrlSislogApi}/v2/order/order-states-count${parameters}`);
    return promise;
  }
}